// extracted by mini-css-extract-plugin
export default {"cart-items":"Cart_cart-items__ei+yV","total":"Cart_total__Ls2tr","actions":"Cart_actions__+TFmt","button--alt":"Cart_button--alt__SS5Za","button":"Cart_button__dPqfc"};